const OPTIMIZABLE_HOSTS = new Set([
    "localhost",
    "95.110.146.22",
    "cdn.sanity.io",
    "foto.gruppopiccirillo.it",
    "lh3.googleusercontent.com",
    "via.placeholder.com",
]);

const INVALID_IMAGE_PATHS = new Set([
    "/autoinarrivo-v2.webp",
    "/autoinarrivo-v2--.webp",
]);

const PROXIED_IMAGE_HOST = "foto.gruppopiccirillo.it";

interface DisplayImageMeta {
    slug?: string | null;
    articolo?: string | number | null;
}

export function normalizeImageSource(src?: string | null, fallback: string = "/autoinarrivo.webp") {
    if (!src || !src.trim()) {
        return fallback;
    }

    const normalized = src.trim();

    if (INVALID_IMAGE_PATHS.has(normalized)) {
        return fallback;
    }

    if (normalized === "/assets" || normalized === "/assets/") {
        return fallback;
    }

    try {
        const parsed = normalized.startsWith("http")
            ? new URL(normalized)
            : new URL(normalized, "https://local.invalid");

        if (parsed.pathname === "/assets" || parsed.pathname === "/assets/") {
            return fallback;
        }
    } catch {
        return fallback;
    }

    return normalized;
}

export function isPlaceholderImageSource(src?: string | null, fallback: string = "/autoinarrivo.webp") {
    return normalizeImageSource(src, fallback) === fallback;
}

export function getDisplayImageSource(
    src?: string | null,
    fallback: string = "/autoinarrivo.webp",
    meta?: DisplayImageMeta
) {
    const normalized = normalizeImageSource(src, fallback);

    if (normalized === fallback) {
        return fallback;
    }

    try {
        const parsed = normalized.startsWith("http")
            ? new URL(normalized)
            : null;

        if (parsed?.hostname === PROXIED_IMAGE_HOST) {
            const params = new URLSearchParams({ url: normalized });

            if (meta?.slug) {
                params.set("slug", meta.slug);
            }

            if (meta?.articolo !== null && meta?.articolo !== undefined && String(meta.articolo).trim()) {
                params.set("articolo", String(meta.articolo));
            }

            return `/api/image-proxy?${params.toString()}`;
        }
    } catch {
        return fallback;
    }

    return normalized;
}

export function canOptimizeImageSource(src?: string | null) {
    if (!src) {
        return false;
    }

    if (src.startsWith("/api/image-proxy")) {
        return false;
    }

    if (src.startsWith("/")) {
        return true;
    }

    try {
        const { hostname } = new URL(src);
        return OPTIMIZABLE_HOSTS.has(hostname);
    } catch {
        return false;
    }
}
